// Browser extensions inject scripts into the page, and when one of them throws the
// error reaches window.onerror exactly like ours would, so the Traceway SDK reports
// it against this app (Urban VPN's executors/200.js alone produced hundreds of
// thousands of "reading 'M_ID'" events). The SDK keeps only file basenames in the
// stack it hands to beforeCapture, so the script origin has to be checked here,
// before its handler runs: these listeners are registered ahead of the SDK's, and
// stopping immediate propagation keeps the SDK from ever seeing the event.

const EXTENSION_URL =
  /^(?:chrome|moz|safari|safari-web|ms-browser)-extension:\/\/|^webkit-masked-url:\/\//;

const FRAME_LOCATION = /(?:\(|@|\s)([a-z][a-z0-9+.-]*:\/\/[^\s()]+):\d+:\d+/i;

function isExtensionUrl(url: string | undefined): boolean {
  return !!url && EXTENSION_URL.test(url);
}

function throwingFrameUrl(error: unknown): string | undefined {
  if (!(error instanceof Error) || !error.stack) {
    return undefined;
  }
  const frame = error.stack.split('\n').find((line) => FRAME_LOCATION.test(line));
  return frame ? FRAME_LOCATION.exec(frame)?.[1] : undefined;
}

export function isBrowserExtensionError(source: string | undefined, error: unknown): boolean {
  return isExtensionUrl(source) || isExtensionUrl(throwingFrameUrl(error));
}

export function installBrowserExtensionErrorFilter() {
  window.addEventListener('error', (event) => {
    if (isBrowserExtensionError(event.filename, event.error)) {
      event.stopImmediatePropagation();
    }
  });
  window.addEventListener('unhandledrejection', (event) => {
    if (isBrowserExtensionError(undefined, event.reason)) {
      event.stopImmediatePropagation();
    }
  });
}
